import { Button, Form } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { emailPattern, mobilePattern } from "../../../Utils";
import {
  GenerateCreditCardGenerationLink,
  GenerateLeadGenerationLink,
} from "../../../ApiServices/Apifun";
import CommonInput from "../../../Common/CommonInput";
import { setselectedTab } from "../../../Store/B2bslice";

const LeadGenerationForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [leadType, setLeadType] = useState([]);
  const formref = useRef();
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    dispatch(setselectedTab("105"));
  }, []);

  const handleLeadGeneration = (val) => {
    let formdata = new FormData();

    formdata.append("name", val.name);
    formdata.append("mobile_no", val.mobile);
    formdata.append("email", val.email);
    formdata.append("lead_type", leadType);
    GenerateLeadGenerationLink(formdata)
      .then((res) => {
        if (res.status) {
          const { url, encdata } = res.data;

          const form = document.createElement("form");
          form.method = "POST";
          form.action = url;
          form.target = "_blank";

          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "encdata";
          input.value = encdata;

          form.appendChild(input);
          document.body.appendChild(form);

          form.submit();

          document.body.removeChild(form);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleCreditCardLeadGeneration = (val) => {
    let formdata = new FormData();

    formdata.append("name", val.name);
    formdata.append("mobile_no", val.mobile);
    formdata.append("email", val.email);
    GenerateCreditCardGenerationLink(formdata)
      .then((res) => {
        if (res.status) {
          const { url, encdata } = res.data;

          const form = document.createElement("form");
          form.method = "POST";
          form.action = url;
          form.target = "_blank";

          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "encdata";
          input.value = encdata;

          form.appendChild(input);
          document.body.appendChild(form);

          form.submit();

          document.body.removeChild(form);
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      <div className="grid grid-cols-1  place-items-start">
        {[
          { id: 1, name: " Loan Lead" },
          // { id: 2, name: "Credit Card" },
        ].map((i, index) => {
          return (
            <div className="w-full text-center">
              <p
                onClick={() => {
                  setSelected(index);
                  form.resetFields();
                }}
                className={`cursor-pointer transition-all  ${
                  i.id - 1 === selected
                    ? "bg-primary tab-active text-white"
                    : "border border-[#EBEBEB]"
                }  py-2 `}
              >
                {i.name}
              </p>
            </div>
          );
        })}
        {selected === 0 ? (
          <div className="prepaid animate-slide-in w-full md:w-1/2 mt-4 bg-white shadow-normal  rounded-3xl p-5">
            <p className="font-bold text-[15px] mb-2"> Loan Lead </p>
            <Form
              name="form"
              form={form}
              ref={formref}
              onFinishFailed={(err) => console.log(err)}
              onFinish={(val) => handleLeadGeneration(val)}
            >
              <Form.Item
                name={`name`}
                label={" Name"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter  Name!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter  Name" name="name" />
              </Form.Item>{" "}
              <Form.Item
                name={`mobile`}
                label={"Mobile No."}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Mobile number must be a valid 10-digit number",
                  },
                  {
                    whitespace: true,
                    message: "Mobile number cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Mobile No" name="mobile" />
              </Form.Item>
              <Form.Item
                name={`email`}
                label={"Email id"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Amount!",
                  },
                  {
                    pattern: emailPattern,
                    message: "Enter Valid Email Id",
                  },
                ]}
              >
                <CommonInput placeholder="Enter email" name="email" />
              </Form.Item>
              <Form.Item
                name={`lead_type`}
                label={"Lead Type"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select Lead!",
                  },
                ]}
              >
                <select
                  className="w-full border border-gray-300 rounded-lg  text-sm"
                  value={leadType}
                  onChange={(e) => setLeadType(e.target.value)}
                >
                  <option value="">----Select Lead Type----</option>
                  <option value="PL">Personal Loan</option>
                  <option value="BL">Business Loan</option>
                  <option value="IL">Instant loan</option>
                  <option value="SA">Savings Account</option>
                </select>
              </Form.Item>{" "}
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Generate Lead
              </Button>
            </Form>
          </div>
        ) : (
          <div className="prepaid animate-slide-in w-full md:w-1/2 mt-4 bg-white shadow-normal  rounded-3xl p-5">
            <p className="font-bold text-[15px] mb-2"> Credit Card</p>
            <Form
              name="form"
              form={form}
              ref={formref}
              onFinishFailed={(err) => console.log(err)}
              onFinish={(val) => handleCreditCardLeadGeneration(val)}
            >
              <Form.Item
                name={`name`}
                label={" Name"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter  Name!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter  Name" name="name" />
              </Form.Item>{" "}
              <Form.Item
                name={`mobile`}
                label={"Mobile No."}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Mobile number must be a valid 10-digit number",
                  },
                  {
                    whitespace: true,
                    message: "Mobile number cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Mobile No" name="mobile" />
              </Form.Item>
              <Form.Item
                name={`email`}
                label={"Email id"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Amount!",
                  },
                  {
                    pattern: emailPattern,
                    message: "Enter Valid Email Id",
                  },
                ]}
              >
                <CommonInput placeholder="Enter email" name="email" />
              </Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Generate Credit Card Lead
              </Button>
            </Form>
          </div>
        )}
      </div>
    </>
  );
};

export default LeadGenerationForm;
